export default __webpack_public_path__ + "static/media/i229jk.4d75eef7.webp";